import { toastEventDispatch } from '@space-lib-events/toast'
import { ToastPosition, ToastType } from '@space-lib-events/toast/enum'
import i18n from 'src/i18n'
import { CommentType } from '../postComments'
import { CreateRequestPayload } from './postCommentInput.types'
import { MAX_FILE_NAME } from './constants'

export const createRequestPayload = ({
  comment,
  media,
  parentCommentId = null,
  avatarDimensions
}: CreateRequestPayload) => {
  const mediaType = media?.mediaType
  const mediaKey = media?.mediaKey
  const fileName = media?.file.name
  const truncatedFileName =
    fileName && fileName.length > MAX_FILE_NAME ? fileName?.slice(0, MAX_FILE_NAME) : fileName

  const dimensions = mediaType === CommentType.IMAGE ? media?.file?.dimensions : undefined

  return {
    type: mediaType || CommentType.TEXT,
    message: comment,
    parentCommentId,
    mediaKey,
    avatarDimensions,
    ...(dimensions && {
      mediaHeight: dimensions.height,
      mediaWidth: dimensions.width
    }),
    ...(mediaType === CommentType.DOCUMENT && {
      fileName: truncatedFileName
    })
  }
}

export class CommentsUtils {
  static sendToastSuccessComment() {
    toastEventDispatch({
      type: ToastType.SUCCESS,
      message: i18n.t('toasts.success_post_comment'),
      position: ToastPosition.BOTTOM_RIGHT
    })
  }

  static sendToastFailedComment() {
    toastEventDispatch({
      type: ToastType.DANGER,
      message: i18n.t('comments.failed_publishing'),
      position: ToastPosition.BOTTOM_RIGHT
    })
  }
}
